async function checkPlatform(store, domain = null) {
  let currentDomain = window.location.hostname;
  let currentPath = window.location.pathname;

  currentDomain == "dev-panel.d7ksuper.com"
    ? (currentDomain = "panel.d7ksuper.com")
    : "";
  currentDomain == "dev-b2b.d7ksuper.com"
    ? (currentDomain = "b2b.ucantay.com")
    : "";
  if (domain) {
    currentDomain = domain;
  }

  var payload = {
    currentDomain: currentDomain,
    currentPath: currentPath,
  };

  await store.dispatch("checkPlatformStore/checkPlatform", payload);
  const platform = store.getters["checkPlatformStore/getPlatformId"];

  return { platform: platform };
}

const isLocalhost = window.location.hostname === "localhost";
const allPlatforms = [
  {
    name: "B2B Uçantay",
    domain: "b2b.ucantay.com",
  },
  {
    name: "D7K Panel",
    domain: "panel.d7ksuper.com",
  },
  {
    name: "Dev D7K Panel",
    domain: "dev-panel.d7ksuper.com",
  },
  {
    name: "Etisan",
    domain: "etisan.d7ksuper.com",
  },
  {
    name: "Farhym",
    domain: "panel.farhym.com",
  },
  {
    name: "Faraero",
    domain: "panel.faraero.com.tr",
  },
  {
    name: "Plasten",
    domain: "panel.plasten.com",
  },
];
function getSelectedPlatform() {
  if (isLocalhost) {
    return localStorage.getItem("selectedPlatform");
  } else {
    return null;
  }
}

export { checkPlatform, allPlatforms, isLocalhost, getSelectedPlatform };
